export enum AccidentEnum {
  OPTION1 = "10000",
  OPTION2 = "20000",
}
